import 'dotenv/config';

const {
  REACT_APP_API_URL,
  REACT_APP_FILES_URL,
  REACT_APP_FILES_URL_ESPECIALES,
  REACT_APP_CLOUD_HOSTING
} = process.env;

let config = {
  apiUrl: REACT_APP_API_URL,
  filesUrl: REACT_APP_FILES_URL,
  filesUrlEspeciales: REACT_APP_FILES_URL_ESPECIALES,
  imagesUrl: REACT_APP_CLOUD_HOSTING
};

export { config as default };
